import script from "./SelectorMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectorMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SelectorMenu.vue?vue&type=style&index=0&id=7ec06da2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec06da2"]])

export default __exports__